<template lang="html">
  <v-layout align-center justify-center column fill-height>
    <v-alert
      v-if="loginError && loginError === constants.ERROR_TICKET_EXPIRED"
      :value="true"
      type="error"
    >
      {{ $t('LOGIN_SESSION_EXPIRED') }}
    </v-alert>
    <v-alert
      v-else-if="loginError"
      :value="true"
      type="error"
    >
      {{ $t(loginError) }}
    </v-alert>
    <v-alert
      v-else
      :value="error"
      type="error"
    >
      <span v-if="msgConst">{{ this.$t(msgConst) }}</span>
      <span v-else>{{ $t('ERROR_UNEXPECTED_RESPONSE') }}</span>
    </v-alert>
    <section class="login">
      <v-form ref="form" @submit.prevent="onSubmit">
        <h1>{{ $t('LOGIN_HEADER') }}</h1>
        <v-text-field
          v-model.trim="username"
          name="username"
          :label="$t('LOGIN_USERNAME')"
          placeholder=""
          filled
        ></v-text-field>
        <v-text-field
          v-model.trim="password"
          name="password"
          :label="$t('LOGIN_PASSWORD')"
          placeholder=""
          filled
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          @click:append="showPassword =! showPassword"
        ></v-text-field>
        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="primary"
          type="submit"
        >
          {{ $t('LOGIN_LOGIN') }}
        </v-btn>
      </v-form>
    </section>
  </v-layout>
</template>

<script lang="js">
import { mapGetters } from 'vuex'

import Auth from '../services/Auth'
import constants from '../config/constants'

export default  {
  name: 'Login',
  props: [],
  data() {
    return {
      username: '',
      password: '',
      showPassword: false,
      isLoading: false,
      error: false,
      msgConst: '',
      constants
    }
  },
  computed: {
    ...mapGetters([ 'loginError' ]),
  },
  mounted() {
    // remove "ticket" query param from URL
    let query = Object.assign({}, this.$route.query);
    if (query.ticket) {
      delete query.ticket;
      this.$router.replace({ query });
    }
  },
  methods: {
    onSubmit() {
      this.isLoading = true
      this.error = false
      this.msgConst = ''
      // TODO: add validation

      this.$store.commit('loginError', 0)
      new Auth(this.$api).login(this.username, this.password)
      .then(() => {
        this.isLoading = false
      }, reason => {
// console.log(reason)
        this.isLoading = false
        this.error = true
        if (reason.code === 'AUTH_FAILED') {
          this.msgConst = 'LOGIN_FAILED'
        }
        if (reason.code === 'MISSING_RIGHTS') {
          this.msgConst = '!!! MISSING_RIGHTS'
        }
      })
    }
  },
}
</script>

<style scoped lang="scss">
.login {

}
</style>
